// API Configuration
const getApiBaseUrl = () => {
  // Check for environment variable first
  if (process.env.REACT_APP_API_URL) {
    console.log('Using REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }
  
  // For production, use direct API URL (backend should handle CORS)
  if (process.env.NODE_ENV === 'production') {
    console.log('Using direct API URL for production');
    return 'https://cpo-zaptec-webhook.azurewebsites.net/api/v1';
  }
  
  // Fallback to production backend URL
  console.log('Using fallback API URL: https://cpo-zaptec-webhook.azurewebsites.net/api/v1');
  return 'https://cpo-zaptec-webhook.azurewebsites.net/api/v1';
};

export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  TIMEOUT: 30000, // Increase timeout to 30 seconds
  RETRY_ATTEMPTS: 3,
};

// UI Constants - Non-theme values only
export const UI_CONSTANTS = {
  ANIMATION_DURATION: 300,
  // Note: Colors, spacing, and visual tokens are now centralized in theme.ts
  // Use theme.palette.*, theme.spacing(), and theme.shadows[] instead
};

// Project Status
export const PROJECT_STATUS = {
  ONGOING: 'ongoing',
  COMPLETED: 'completed',
  PLANNED: 'planned',
  ON_HOLD: 'on_hold',
} as const;

// Unit Types
export const UNIT_TYPES = {
  BATTERY: 'battery',
  CHARGER: 'charger',
  SWITCHBOARD: 'switchboard',
  ENERGY_METER: 'energy-meter',
  EXCAVATOR: 'excavator',
} as const;

// Date Formats
export const DATE_FORMATS = {
  DISPLAY: 'en-GB',
  SHORT: 'dd/MM/yyyy',
  LONG: 'EEEE, MMMM do, yyyy',
} as const;

